<p-card
    class="w-full"
    [header]="'UPLOADED_DOCUMENTS' | translate"
    *ngIf="documents"
>
    <p-table
        [value]="documents"
        [paginator]="false"
        [rows]="5"
        responsiveLayout="scroll"
        *ngIf="getDeviceType() === 'desktop' || getDeviceType() === 'tablet'"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>{{ "DOCUMENT_NAME" | translate }}</th>
                <th>{{ "Document Number" | translate }}</th>
                <th>{{ "EXPIRY_DATE" | translate }}</th>
                <th>{{ "VERIFICATION_DATE" | translate }}</th>
                <th>{{ "Uploaded On" | translate }}</th>
                <th>{{ "STATUS" | translate }}</th>
                <th>{{ "ACTIONS" | translate }}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-document>
            <tr>
                <td>
                    <span class="p-column-title">Document Name</span>
                    {{ document.documentName | translate }}
                    <span
                        class="pi pi-question-circle"
                        pTooltip="{{ document.description | translate }}"
                    ></span>
                </td>
                <td>
                    <span class="p-column-title">Document Number</span>
                    {{
                        document.documentNumber
                            ? document.documentNumber
                            : " - "
                    }}
                </td>
                <td>
                    <span class="p-column-title">Document Expiry Date</span>
                    {{
                        document.expiryDate
                            ? (document.expiryDate | date : "dd-MMM-yyyy")
                            : " -"
                    }}
                </td>
                <td>
                    <span class="p-column-title">Verification Date</span>
                    {{
                        document.verificationDate
                            ? (document.verificationDate | date : "dd-MMM-yyyy")
                            : " -"
                    }}
                </td>
                <td>
                    <span class="p-column-title">Document Upload Date</span>
                    {{ document.uploadDate | date : "dd-MMM-yyyy hh:mm:ss" }}
                </td>
                <td>
                    <span class="p-column-title">Document Status</span>
                    {{ document.status ? (document.status | translate) : " -" }}
                </td>
                <td>
                    <button
                        pButton
                        (click)="downloadClicked(document.id, document)"
                        icon="pi pi-download"
                        [label]="'Download' | translate"
                        class="mt-4"
                    ></button>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div *ngIf="getDeviceType() === 'mobile'" class="flex flex-column gap-4">
        <div
            *ngFor="let document of documents"
            class="flex justify-content-between"
        >
            <div class="document-section flex flex-column">
                <span class="document-name" class="font-bold text-sm font-500">
                    {{ document.documentName | translate }}</span
                >
                <span class="document-type text-sm mt-2">
                    {{ "Document Number" | translate }} :
                    {{
                        document.documentNumber
                            ? document.documentNumber
                            : "---"
                    }}</span
                >
                <span class="expiry-date text-sm"
                    >{{ "Expiry Date" | translate }} :
                    {{
                        document.expiryDate
                            ? (document.expiryDate | date : "medium")
                            : "---"
                    }}</span
                >
            </div>
            <div class="document-section">
                <button
                    pButton
                    [label]="'Download' | translate"
                    (click)="downloadClicked(document.id, document)"
                    icon="pi pi-download"
                ></button>
            </div>
        </div>
    </div>
</p-card>
